import React, { useState } from 'react';
import Button from '../../../../../component/ui/Button';
import Modal from '../../../../../component/modal/Modal';
import { deleteAccount } from '../../../../../services/settings/accounting';
import { toast } from 'react-toastify';

export default function DeleteAccountModel({ isOpenModal, setIsOpenModal, accountId, getList }) {
	const [loader, setLoader] = useState(false);
	const handleDeleteAccount = async () => {
		try {
			setLoader(true);
			const res = await deleteAccount(accountId);
			if (res.success) {
				toast.success(res.message);
				setIsOpenModal(false);
				getList();
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};
	return (
		<Modal
			className="confirmatinBoxModal"
			title={'Are You Sure?'}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div className="fs-4 fw-bold text-center">Are you sure you want to delete this account?</div>
			<div
				className="fs-4 fw-semibold text-center py-2"
				style={{ color: '#979797' }}
			>
				This account will be deleted permanently.
			</div>
			<div className="d-flex align-items-center justify-content-center mt-4 gap-4">
				<Button
					type="button"
					button={`Cancel`}
					dataTestId={'account-delete-cancel-button'}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
				<Button
					type="button"
					disabled={loader}
					loader={loader}
					dataTestId={'account-delete-confirm-button'}
					button={`Confirm`}
					className="mt-0 px-4 btn-primary relative"
					onClick={() => handleDeleteAccount(accountId)}
				/>
			</div>
		</Modal>
	);
}
